import { Component, OnInit, Injector } from '@angular/core';
import { take } from 'rxjs';
import { swErrorMessage } from '../../../../shared/constant/customer-journey/error-message-constant';
import { Utils } from '../../../../shared/Utils/Utils';
import { BaseSWQuestion } from '../../../extended-class/base-ws-question';
import { DateOptionModel } from '../../../models/date-option.model';
import { DateOptionsModel } from '../../../models/date-options.model';
import { LookUpResourceModel } from '../../../models/lookup-resource.model';
import { ValidDateOption } from '../../../models/valid-date-option.model';
import { SectionWiseValidationService } from '../../../service/section-wise-validation.service';

@Component({
  selector: '[policyStartRealDate]',
  templateUrl: './policy-start-real-date.component.html'
})
export class PolicyStartRealDateComponent extends BaseSWQuestion implements OnInit {
  public dateOptionsModel: DateOptionsModel = new DateOptionsModel();
  public selectedDate: DateOptionModel = new DateOptionModel();
  public validDateOption: ValidDateOption;
  private question: LookUpResourceModel;
  private minDate: Date;
  private maxDate: Date;

  public get sWErrorMessage() {
    return swErrorMessage;
  }

  constructor(
    serviceInjector: Injector,
    private sectionWiseValidationService: SectionWiseValidationService
  ) {
    super(serviceInjector);
  }

  public ngOnInit() {
    this.validDateOption = new ValidDateOption();

    const currentDate = new Date();
    this.minDate = new Date(currentDate);
    this.maxDate = new Date(currentDate.setMonth(currentDate.getMonth() + 6));

    this.activatedRoute.queryParams.subscribe((param: any) => {
      this.mapPolicyStartRealDate(JSON.parse(param['question']));
    });

    this.swProcessStateService.swContractType$.pipe(take(1)).subscribe((contractType) => {
      this.contractType = contractType;

      if (contractType.policyStartRealDate) {
        this.selectedDate = Utils.getDateOption(contractType.policyStartRealDate);
      }
    });
  }

  public saveSectionAnswer() {
    const { day, month, year } = this.selectedDate;

    this.validDateOption = this.sectionWiseValidationService.getValidDateOption(this.selectedDate, this.minDate, this.maxDate, true);
    if (this.isValid(this.validDateOption)) {
      this.contractType.policyStartRealDate = new Date(Date.UTC(year, month - 1, day ?? 1));
      this.addGTMAnswer(this.question.QuestionNumber, this.contractType.policyStartRealDate.toDateString());
      this.swProcessStateService.updateSwProcessModel(this.contractType);
      this.sectionWiseService.closeSwqModal(this.question);
    } else {
      this.gtmDatalayerUiService.addVirtualPageValidationError('Q2', 1, 'Por favor, selecciona una fecha válida.').toPromise();
    }
  }

  private mapPolicyStartRealDate(question: LookUpResourceModel) {
    const currentDate = new Date();
    this.question = question;

    this.dateOptionsModel.days = [];
    this.dateOptionsModel.days.push({ Text: 'Día', Value: 0 });
    for (let day = 1; day <= 31; day++) {
      this.dateOptionsModel.days.push({ Text: day + '', Value: day });
    }

    this.dateOptionsModel.months = [{ Text: 'Mes', Value: 0 }];
    for (let monthOffset = 1; monthOffset <= 6; monthOffset++) {
      const month = ((currentDate.getMonth() + monthOffset - 1) % 12) + 1;
      this.dateOptionsModel.months.push(...question.Options.filter((option) => option.Value === month));
    }

    this.dateOptionsModel.years = [{ Text: 'Año', Value: 0 }];
    for (let year = currentDate.getFullYear(); year <= currentDate.getFullYear() + 1; year++) {
      this.dateOptionsModel.years.push({ Text: year + '', Value: year });
    }
  }

  private isValid(validDateOption: ValidDateOption) {
    return validDateOption.isValidDate && validDateOption.isValidDay && validDateOption.isValidMonth && validDateOption.isValidYear;
  }
}